// takk til https://plainenglish.io/blog/here-are-2-javascript-approaches-to-encode-decode-html-entities-52989bb12031
import {erNill} from "felles/stoettefunk/nillsjekk";

export function dekodHexHtmlEntiteter(streng: string) {
    if(erNill(streng)) {
        return "";
    }
    return streng.replace(/&#(\d+);/g, ((treff, dec) => `${String.fromCharCode(dec)}`));
}
